import { ANALYTICS_EVENTS, ANALYTICS_PROPERTY_KEYS, COMPONENT_OUTCOMES, DCM_PAGES } from '../constants';
import { trackAnalyticsEvent } from '../core/analyticsClient';

export type TrackCampaignStatusChangedParams = {
  campaignId: string;
  adAccountId?: string;
  fromStatus: string;
  toStatus: string;
  page?: (typeof DCM_PAGES)[keyof typeof DCM_PAGES];
};

export const trackCampaignStatusChanged = ({
  campaignId,
  adAccountId,
  fromStatus,
  toStatus,
  page = DCM_PAGES.CAMPAIGN_PAYMENT,
}: TrackCampaignStatusChangedParams): void => {
  trackAnalyticsEvent(ANALYTICS_EVENTS.CAMPAIGN_STATUS_CHANGED, {
    [ANALYTICS_PROPERTY_KEYS.CAMPAIGN_ID]: campaignId,
    [ANALYTICS_PROPERTY_KEYS.AD_ACCOUNT_ID]: adAccountId,
    [ANALYTICS_PROPERTY_KEYS.FROM_STATUS]: fromStatus,
    [ANALYTICS_PROPERTY_KEYS.TO_STATUS]: toStatus,
    [ANALYTICS_PROPERTY_KEYS.PAGE]: page,
    [ANALYTICS_PROPERTY_KEYS.COMPONENT_OUTCOME]: COMPONENT_OUTCOMES.USER,
  });
};
